export default __webpack_public_path__ + "static/sunsoaked-banner-mobile-f3d14a9641917881e4efcc96aa52a698.webp";